<template lang="pug">
  .box-header-group.board-info
    .item-content
      .item-title
        span {{item.name}}
    .item-number-count
      .item-group(@click="gotoListLesson(item)")
        span {{$mycontroller.numberWithCommas(countLesson)}}
        img(src="../../assets/images/faces/ic_lythuyet@2x.png")
      .item-group(@click="gotoListVideo(item)")
        span {{$mycontroller.numberWithCommas(countVideo)}}
        img(src="../../assets/images/faces/ic_video@2x.png")
      .item-group(@click="gotoListExercise(item)")
        span {{$mycontroller.numberWithCommas(countExercise)}}
        img(src="../../assets/images/faces/ic_baitap@2x.png")
    .clearfix
</template>
<script>
import gql from 'graphql-tag'
import graphql from '../Model/graphql'
import MdNotification from '@/core/components/mdNotification'
import moment from 'moment'
export default {
  components: {
    MdNotification
  },
  props: {
    item: Object,
    pcID: Number
  },
  data() {
    return {
      message: this.$t('home.comming_soon'),
      isPopoverClass: this.keyPopoverClass,
      isSmart: this.keySmart,
      countLesson: 0,
      countVideo: 0,
      countExercise: 0
    }
  },
  methods: {
    showNotification(message, color, from, align, timeout) {
      this.$notifications.notify({
        type: color,
        icon: 'notifications',
        message: message,
        placement: {
          from,
          align
        },
        timeout: timeout
      })
    },
    formatDate(value) {
      return moment(value).format('DD/MM/YYYY - hh:mm')
    },
    gotoListLesson(item) {
      this.$router.push({name: 'lesson_planning_lesson', query: {id: this.pcID}, params: {classes_id: this.item.id}})
    },
    gotoListVideo(item) {
      this.$router.push({name: 'lesson_planning_video', query: {id: this.pcID}, params: {classes_id: this.item.id}})
    },
    gotoListExercise(item) {
      this.$router.push({name: 'lesson_planning_exercise', query: {id: this.pcID}, params: {classes_id: this.item.id}})
    },
    async getCountLesson() {
      var variables = {
        lesson: {type_lesson: {_eq: 1}},
        class_id: {_eq: this.item.id}
        // class: {pc_id: {_eq: this.pcID}}
      }
      const {data} = await this.$apollo.query({
        query: gql(graphql.GET_COUNT_LESSON_CLASS_IN_PC),
        fetchPolicy: 'no-cache',
        variables: {
          where: variables
        }
      }).catch((error) => {
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0)
        }
        console.error(error.message)
      })
      if (data && data !== null) {
        this.countLesson = data.lesson_class_aggregate.aggregate.count
      }
    },
    async getCountVideo() {
      var variables = {
        lesson: {type_lesson: {_eq: 2}},
        class_id: {_eq: this.item.id}
        // class: {pc_id: {_eq: this.pcID}}
      }
      const {data} = await this.$apollo.query({
        query: gql(graphql.GET_COUNT_LESSON_CLASS_IN_PC),
        fetchPolicy: 'no-cache',
        variables: {
          where: variables
        }
      }).catch((error) => {
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0)
        }
        console.error(error.message)
      })
      if (data && data !== null) {
        this.countVideo = data.lesson_class_aggregate.aggregate.count
      }
    },
    async getCountExercise() {
      var variables = {
        class_id: {_eq: this.item.id},
        class: {pc_id: {_eq: this.pcID}}
      }
      const {data} = await this.$apollo.query({
        query: gql(graphql.GET_COUNT_EXERCISE_IN_PC),
        fetchPolicy: 'no-cache',
        variables: {
          where: variables
        }
      }).catch((error) => {
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0)
        }
        console.error(error.message)
      })
      if (data && data !== null) {
        this.countExercise = data.exercise_class_aggregate.aggregate.count
      }
    }
  },
  async mounted () {
    await this.getCountLesson()
    await this.getCountVideo()
    await this.getCountExercise()
  },
  apollo: {
  }
}
</script>

<style lang="scss">
  .item-classes-pc{
    .board{cursor: pointer; padding: 5px 8px 15px; background: #FFFFFF 0% 0% no-repeat padding-box; box-shadow: 0px 1px 2px #00000029;border-radius: 10px; display: block;
      .board-info{ margin-top: 16px;
        .title-classes{color: #343A40; font-size: 15px; min-height: 40px; display: table; width: 100%; text-align: center; 
          span{display: table-cell; vertical-align: middle;}
        }
      }
    }
  }
@media screen and (max-width: 1366px){
  
}
@media screen and (max-width: 1024px){
  
}
@media screen and (max-width: 991px){
  .item-classes-pc{ width: 25%;
  }
}
@media screen and (max-width: 768px){
}
@media screen and (max-width: 640px){
  .item-classes-pc{ width: 33.33%;}
}
@media screen and (max-width: 480px){
  .item-classes-pc{ width: 50%;}
}
</style>



// WEBPACK FOOTER //
// itemClasses.vue?4778374a